var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCreditCardPrimaryLg = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 220,
  height: 166,
  fill: "none",
  viewBox: "0 0 220 166",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 80,
  r: 80,
  fill: "var(--utility-brand-200, black)"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 12,
  r: 8,
  fill: "var(--utility-brand-100, black)"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 198,
  cy: 142,
  r: 6,
  fill: "var(--utility-brand-100, black)"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 138,
  r: 10,
  fill: "var(--utility-brand-100, black)"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 210,
  cy: 46,
  r: 10,
  fill: "var(--utility-brand-100, black)"
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 191,
  cy: 11,
  r: 7,
  fill: "var(--utility-gray-100, black)"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 166,
  height: 104,
  x: 27,
  y: 22,
  fill: "var(--utility-brand-100, black)",
  rx: 7.256
}), /*#__PURE__*/React.createElement("rect", {
  width: 29.023,
  height: 21.767,
  x: 41.07,
  y: 46.186,
  fill: "var(--utility-brand-300, black)",
  rx: 2.419
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166.837,
  cy: 53.442,
  r: 12.093,
  fill: "var(--utility-brand-400, black)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152.325,
  cy: 53.442,
  r: 12.093,
  fill: "var(--utility-brand-300, black)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-brand-300, black)",
  d: "M41.07 110.279a2.42 2.42 0 0 1 2.418-2.419h24.186a2.419 2.419 0 0 1 0 4.838H43.488a2.42 2.42 0 0 1-2.418-2.419M77.349 110.279a2.42 2.42 0 0 1 2.418-2.419h24.187a2.419 2.419 0 0 1 0 4.838H79.768a2.42 2.42 0 0 1-2.42-2.419M113.628 110.279a2.42 2.42 0 0 1 2.419-2.419h24.186a2.419 2.419 0 0 1 0 4.838h-24.186a2.42 2.42 0 0 1-2.419-2.419M149.907 110.279a2.42 2.42 0 0 1 2.419-2.419h24.186a2.419 2.419 0 0 1 0 4.838h-24.186a2.42 2.42 0 0 1-2.419-2.419"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-brand-400, black)",
  d: "M82 120c0-15.464 12.536-28 28-28s28 12.536 28 28-12.536 28-28 28-28-12.536-28-28"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--fg-white)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M110 115.333V120m0 4.667h.012M121.667 120c0 6.443-5.224 11.667-11.667 11.667S98.333 126.443 98.333 120s5.224-11.667 11.667-11.667 11.667 5.224 11.667 11.667"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "a",
  width: 206,
  height: 144,
  x: 7,
  y: 22,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 4,
  result: "effect1_dropShadow_1182_2628"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1182_2628"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 4,
  result: "effect2_dropShadow_1182_2628"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 20
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 12
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_1182_2628",
  result: "effect2_dropShadow_1182_2628"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow_1182_2628",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "b",
  width: 72,
  height: 72,
  x: 74,
  y: 84,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_1182_2628"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_1182_2628",
  result: "shape"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCreditCardPrimaryLg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CreditCardPrimaryLg.2dd911ccbb011a62a369ab25a1665d03.svg";